import { Tabs } from '@mantine/core';
import classNames from './tabs.module.css';
export const tabsProps = Tabs.extend({
    classNames,
});
